import { doc, serverTimestamp, writeBatch } from 'firebase/firestore'
import { db } from '../firebase'
import ensureSurveyFirebaseSession from './ensureSurveyFirebaseSession'

export default async function saveSurveyResult({ surveyCode, responseId, result }) {
  const normalizedSurveyCode = String(surveyCode || '').trim()
  const normalizedResponseId = String(responseId || '').trim()

  if (!normalizedSurveyCode) {
    throw new Error('Survey code is required')
  }

  if (!normalizedResponseId) {
    throw new Error('Survey response ID is required')
  }

  if (!result || typeof result !== 'object' || Array.isArray(result)) {
    throw new Error('Survey result must be a JSON object')
  }

  const surveyDocumentId = encodeURIComponent(normalizedSurveyCode)
  const responseDocumentId = encodeURIComponent(normalizedResponseId)
  const firebaseUser = await ensureSurveyFirebaseSession()
  const surveyReference = doc(db, 'surveys', surveyDocumentId)
  const responseReference = doc(surveyReference, 'responses', responseDocumentId)
  const batch = writeBatch(db)

  batch.set(
    surveyReference,
    {
      code: normalizedSurveyCode,
      last_response_at: serverTimestamp(),
    },
    { merge: true }
  )
  batch.set(responseReference, {
    ...result,
    firebase_uid: firebaseUser.uid,
    firebase_auth_type: firebaseUser.isAnonymous ? 'anonymous' : 'authenticated',
  })

  await batch.commit()
}
